import React from "react";
import Widgets from "../../Widgets";
import { t } from "../../Utils/translate";
import "./reassignDoc.css"

const DoctorSelection = ({
  depList,
  selectedDep,
  doctorList,
  selectedDoctor,
  doctorDurations,
  onDropdownChange,
  onDoctorSelection,
  onDoctorDurationChange,
  getDoctorPrice
}) => {
  const renderDoctorDurationOptions = (doctor) => {
    if (!doctor.availableDurationPrices?.length) return null;

    const currentDuration = doctorDurations[doctor._id];

    return (
      <div className="duration-options">
        {doctor.availableDurationPrices.map((item, index) => (
          <div key={index} className="flex items-center gap-2 mb-1 cursor-pointer doctor-id-cell">
            <input
              type="radio"
              name={`duration-${doctor._id}`}
              onChange={() => onDoctorDurationChange(doctor._id, item)}
              id={`duration-${doctor._id}-${index}`}
              checked={currentDuration?.duration === item.duration}
            />
            <label htmlFor={`duration-${doctor._id}-${index}`} className="text-sm">
              {item.duration} min
            </label>
          </div>
        ))}
      </div>
    );
  };

  const renderDoctorTable = () => (
    <div className="doctor-table-container">
      <div className="doctor-table-wrapper">
        <table className="doctor-table">
          <thead>
            <tr>
              <th>{t('doctorId')}</th>
              <th>{t('nameGender')}</th>
              <th>{t('qualification')}</th>
              <th>{t('grade')}</th>
              <th>{t('fees')}</th>
              <th>{t('duration')}</th>
            </tr>
          </thead>
          <tbody>
            {doctorList.length === 0 ? <><label className="p-4 text-nowrap relative ">{t("noDocAvail")}</label></> : 
              doctorList.map((doctor, index) => (
              <tr key={doctor._id}>
                <td data-label="Doctor ID" className="border-b border-gray-300">
                  <div className="doctor-id-cell">
                    <input
                      type="radio"
                      name="docSelected"
                      className="custom-radio"
                      id={`docSelected-${index}`}
                      checked={doctor._id === selectedDoctor.doctor?._id}
                      onChange={() => onDoctorSelection(doctor)}
                    />
                    <label htmlFor={`docSelected-${index}`}>{index + 1}</label>
                  </div>
                </td>
                <td data-label="Doctor Name">  {doctor.name.length > 30 ? doctor.name.slice(0, 30) + "…" : doctor.name}</td>
                <td data-label="Qualification">{doctor.qualification.length > 30 ? doctor.qualification.slice(0, 30) + "…" : doctor.qualification}</td>
                <td data-label="Grade">{doctor.grade}</td>
                <td data-label="Fees">
                  {getDoctorPrice(doctor._id)}
                </td>
                <td data-label="Duration Options">
                  {renderDoctorDurationOptions(doctor)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>        
    </div>
  );



  return (
    <>
      <div className="rr-sel-dropdown">
        <Widgets.NewSelDropdown
          options={depList}
          placeholder={"selDep"}
          noMargin
          selectedValue={selectedDep}
          onChange={onDropdownChange}
          disableTruncat={true}
          big={false}
          backgroundColor={"#FFFFFF"}
          textColor={"#000000"}
        />
      </div>
      
      {renderDoctorTable()}

    </>
  );
};

export default DoctorSelection;